import type {ColumnModel} from '../../../models/column-model'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {getColumnModel} from './column-api'
import type {ColumnInstance, Header} from './types'

export const getHeaderColumnModel = (header: Header<MemexItemModel>): ColumnModel | undefined => {
  return getColumnModel(header.column)
}

/**
 * @deprecated - Use `header.column` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const getHeaderColumn = (header: Header<MemexItemModel>): ColumnInstance<MemexItemModel> => {
  return header.column
}

export const getCanReorder = (header: Header<MemexItemModel>): boolean => {
  return !header.column.getIsPinned()
}

/**
 * @deprecated - Use `header.colSpan` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const getColSpan = (header: Header<MemexItemModel>): number => {
  return header.colSpan
}

/**
 * @deprecated - Use `header.column.getCanResize()` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const getCanResize = (header: Header<MemexItemModel>): boolean => {
  return header.column.getCanResize()
}

export const getSortInfo = (header: Header<MemexItemModel>) => {
  const sorted = header.column.getIsSorted()
  return {
    isSorted: sorted !== false,
    isSortedDesc: sorted === false ? undefined : sorted === 'desc',
    sortedIndex: header.column.getSortIndex(),
  }
}

/**
 * @deprecated - Use `header.column.getIsGrouped()` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const headerIsGrouped = (header: Header<MemexItemModel>): boolean => {
  return header.column.getIsGrouped()
}

export const getResizerProps = (header: Header<MemexItemModel>): React.HTMLAttributes<HTMLElement> => {
  return {
    onTouchStart: header.getResizeHandler(),
    onMouseDown: header.getResizeHandler(),
    style: {
      cursor: 'col-resize',
    },
    draggable: false,
    role: 'separator',
  }
}

/**
 * @deprecated - Use `header.column.getIsResizing()` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const getIsResizing = (header: Header<MemexItemModel>): boolean => {
  return header.column.getIsResizing()
}
